// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-dialog-container {
  width: 510px;
  height: 490px;
  position: absolute;
  left: calc(50% - 255px);
  top: calc(50% - 245px);
  overflow: hidden;
  opacity: 1;
  z-index: 20;
  border-radius: 5px;
  animation: popup 0.1s ease-in-out 0s 1;
}
.setting-dialog-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 15px;
  opacity: 1;
  margin: 15px 0px 10px;
  text-align: center;
}
.setting-dialog-new-title {
  font-size: 15px;
  line-height: 20px;
  margin-top: 10px;
  margin-left: 25px;
  width: calc(100% - 50px);
  margin-bottom: 5px;
  /* width: 280px; */
  display: flex;
  justify-content: space-between;
  font-weight: 500;
}
.account-login-tips {
  font-size: 15px;
  opacity: 0.8;
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
}
.setting-dialog-list {
  font-size: 15px;
  line-height: 18px;
  opacity: 1;
  margin: 7px;
}
.setting-dialog-new-container {
  margin: 20px 30px;
}
.setting-dialog-info {
  height: 340px;
  overflow-y: scroll;
}
.setting-dialog-illustration {
  width: 200px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  z-index: 20;
}
.setting-dialog-url {
  width: 200px;
  font-size: 13px;
  position: absolute;
  bottom: 6px;
  left: 10px;
  -webkit-user-select: text;
          user-select: text;
  z-index: 30;
  line-height: 16px;
}
.setting-dialog-subtitle {
  font-size: 15px;
  margin: 7px 10px;
  text-align: center;
  color: #0078d4;
  float: left;
}
.setting-tab {
  max-width: 18% !important;
  text-overflow: ellipsis;
  max-height: 40px;
}
.setting-language {
  width: 30px;
  height: 30px;
  font-size: 30px;
  cursor: pointer;
  float: right;
}

.setting-close-container {
  position: absolute;
  top: 10px;
  right: 10px;
  transition: 0.1s;
  width: 38px;
  height: 38px;
  cursor: pointer;
}

.setting-close-container:hover {
  border-radius: 50%;
}
.setting-close {
  margin-right: 10px;
  margin-top: 10px;
  float: right;
  font-size: 18px;
  cursor: pointer;
}
.setting-subtitle {
  font-size: 15px;
  margin: 5px;
  margin-bottom: 0px;
  text-align: center;
}
.setting-plugin-icon {
  margin: 5px;
  font-size: 18px;
  display: inline-block;
  width: 20px;
}
.setting-plugin-name {
  position: relative;
  bottom: 3px;
}
.lang-setting-dropdown {
  width: 100px;
  height: 30px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
}
.lang-setting-option {
  font-size: 15px;
  font-weight: 500;
  line-height: 27px;
  text-align: left;
}
.setting-dialog-location-title {
  font-size: 13px;
  font-weight: 500;
  border-radius: 5px;
  padding: 5px;
  /* width: 75%; */
  margin-left: 25px;
  margin-right: 25px;
  text-overflow: ellipsis;
  word-break: break-all;
  margin-top: 6px;
  margin-bottom: 10px;
  -webkit-user-select: text;
          user-select: text;
}
.change-location-button {
  display: inline-block;
  min-width: 50px;
  padding-left: 10px;
  padding-right: 10px;
  height: 22px;
  opacity: 1;
  border-radius: 11px;
  position: relative;
  top: 0px;
  left: 2px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
}
.theme-setting-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px 4px 8px;
  border-radius: 20px;
  border: 2px solid transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.theme-setting-title {
  max-width: 50px;
  width: 50px;
}
.theme-setting-item.active-theme-item {
  border-color: currentColor;
}
.theme-setting-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
}
.theme-setting-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  width: auto;
  height: auto;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 6px;
}
.skin-setting-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 6px;
  margin-bottom: 5px;
}
.custom-color-picker-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.skin-setting-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px 4px 8px;
  border-radius: 20px;
  border: 2px solid transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  box-sizing: border-box;
  opacity: 0.6;
  transition:
    border-color 0.15s,
    opacity 0.15s;
}
.skin-setting-item.active-skin-item {
  border-color: currentColor;
  opacity: 1;
}
.skin-setting-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.setting-option-subtitle {
  font-size: 12px;
  opacity: 0.8;
  margin-left: 25px;
  margin-right: 25px;
  line-height: 15px;
}
.setting-dialog-new-plugin {
  position: absolute;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
}
.plugin-tab-bar {
  display: flex;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 6px 25px;
  gap: 8px;
  margin-bottom: 4px;
}
.plugin-tab-item {
  padding: 4px 16px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  opacity: 0.6;
  transition:
    opacity 0.15s,
    background 0.15s;
  -webkit-user-select: none;
          user-select: none;
}
.plugin-tab-item:hover {
  opacity: 0.9;
}
.plugin-tab-item-active {
  opacity: 1;
}
.plugin-section-anchor {
  height: 0;
  overflow: hidden;
}
.token-dialog-button-container {
  margin-top: 20px;
  margin-bottom: 30px;
}
.token-dialog-token-box {
  width: 100%;
  height: 100px;
  opacity: 1;
  font-size: 13px;
  line-height: 14px;
  opacity: 1;
  box-sizing: border-box;
  /* left: 30px; */
  border-radius: 5px;
  padding: 5px;
  margin-top: 10px;
  box-sizing: border-box;
}
.token-dialog-username-box {
  width: 100%;
  height: 30px;
  opacity: 1;
  font-size: 13px;
  line-height: 14px;
  opacity: 1;
  margin-top: 9px;
  padding-left: 5px;
  border-radius: 5px;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/settingDialog/settingDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ;;iBAEe;AACjB;AACA;EACE,0BAA0B;EAC1B,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ;;oBAEkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".setting-dialog-container {\n  width: 510px;\n  height: 490px;\n  position: absolute;\n  left: calc(50% - 255px);\n  top: calc(50% - 245px);\n  overflow: hidden;\n  opacity: 1;\n  z-index: 20;\n  border-radius: 5px;\n  animation: popup 0.1s ease-in-out 0s 1;\n}\n.setting-dialog-title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 15px;\n  opacity: 1;\n  margin: 15px 0px 10px;\n  text-align: center;\n}\n.setting-dialog-new-title {\n  font-size: 15px;\n  line-height: 20px;\n  margin-top: 10px;\n  margin-left: 25px;\n  width: calc(100% - 50px);\n  margin-bottom: 5px;\n  /* width: 280px; */\n  display: flex;\n  justify-content: space-between;\n  font-weight: 500;\n}\n.account-login-tips {\n  font-size: 15px;\n  opacity: 0.8;\n  width: 100%;\n  margin: 0 auto;\n  margin-top: 30px;\n  text-align: center;\n}\n.setting-dialog-list {\n  font-size: 15px;\n  line-height: 18px;\n  opacity: 1;\n  margin: 7px;\n}\n.setting-dialog-new-container {\n  margin: 20px 30px;\n}\n.setting-dialog-info {\n  height: 340px;\n  overflow-y: scroll;\n}\n.setting-dialog-illustration {\n  width: 200px;\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  z-index: 20;\n}\n.setting-dialog-url {\n  width: 200px;\n  font-size: 13px;\n  position: absolute;\n  bottom: 6px;\n  left: 10px;\n  user-select: text;\n  z-index: 30;\n  line-height: 16px;\n}\n.setting-dialog-subtitle {\n  font-size: 15px;\n  margin: 7px 10px;\n  text-align: center;\n  color: #0078d4;\n  float: left;\n}\n.setting-tab {\n  max-width: 18% !important;\n  text-overflow: ellipsis;\n  max-height: 40px;\n}\n.setting-language {\n  width: 30px;\n  height: 30px;\n  font-size: 30px;\n  cursor: pointer;\n  float: right;\n}\n\n.setting-close-container {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  transition: 0.1s;\n  width: 38px;\n  height: 38px;\n  cursor: pointer;\n}\n\n.setting-close-container:hover {\n  border-radius: 50%;\n}\n.setting-close {\n  margin-right: 10px;\n  margin-top: 10px;\n  float: right;\n  font-size: 18px;\n  cursor: pointer;\n}\n.setting-subtitle {\n  font-size: 15px;\n  margin: 5px;\n  margin-bottom: 0px;\n  text-align: center;\n}\n.setting-plugin-icon {\n  margin: 5px;\n  font-size: 18px;\n  display: inline-block;\n  width: 20px;\n}\n.setting-plugin-name {\n  position: relative;\n  bottom: 3px;\n}\n.lang-setting-dropdown {\n  width: 100px;\n  height: 30px;\n  font-size: 15px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n}\n.lang-setting-option {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 27px;\n  text-align: left;\n}\n.setting-dialog-location-title {\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 5px;\n  padding: 5px;\n  /* width: 75%; */\n  margin-left: 25px;\n  margin-right: 25px;\n  text-overflow: ellipsis;\n  word-break: break-all;\n  margin-top: 6px;\n  margin-bottom: 10px;\n  user-select: text;\n}\n.change-location-button {\n  display: inline-block;\n  min-width: 50px;\n  padding-left: 10px;\n  padding-right: 10px;\n  height: 22px;\n  opacity: 1;\n  border-radius: 11px;\n  position: relative;\n  top: 0px;\n  left: 2px;\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 1;\n}\n.theme-setting-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px 4px 8px;\n  border-radius: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n.theme-setting-title {\n  max-width: 50px;\n  width: 50px;\n}\n.theme-setting-item.active-theme-item {\n  border-color: currentColor;\n}\n.theme-setting-dot {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.theme-setting-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  width: auto;\n  height: auto;\n  margin-left: 25px;\n  margin-right: 25px;\n  margin-top: 6px;\n}\n.skin-setting-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-left: 25px;\n  margin-right: 25px;\n  margin-top: 6px;\n  margin-bottom: 5px;\n}\n.custom-color-picker-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.skin-setting-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px 4px 8px;\n  border-radius: 20px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  box-sizing: border-box;\n  opacity: 0.6;\n  transition:\n    border-color 0.15s,\n    opacity 0.15s;\n}\n.skin-setting-item.active-skin-item {\n  border-color: currentColor;\n  opacity: 1;\n}\n.skin-setting-icon {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n.setting-option-subtitle {\n  font-size: 12px;\n  opacity: 0.8;\n  margin-left: 25px;\n  margin-right: 25px;\n  line-height: 15px;\n}\n.setting-dialog-new-plugin {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  cursor: pointer;\n}\n.plugin-tab-bar {\n  display: flex;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  padding: 6px 25px;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n.plugin-tab-item {\n  padding: 4px 16px;\n  border-radius: 14px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  opacity: 0.6;\n  transition:\n    opacity 0.15s,\n    background 0.15s;\n  user-select: none;\n}\n.plugin-tab-item:hover {\n  opacity: 0.9;\n}\n.plugin-tab-item-active {\n  opacity: 1;\n}\n.plugin-section-anchor {\n  height: 0;\n  overflow: hidden;\n}\n.token-dialog-button-container {\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n.token-dialog-token-box {\n  width: 100%;\n  height: 100px;\n  opacity: 1;\n  font-size: 13px;\n  line-height: 14px;\n  opacity: 1;\n  box-sizing: border-box;\n  /* left: 30px; */\n  border-radius: 5px;\n  padding: 5px;\n  margin-top: 10px;\n  box-sizing: border-box;\n}\n.token-dialog-username-box {\n  width: 100%;\n  height: 30px;\n  opacity: 1;\n  font-size: 13px;\n  line-height: 14px;\n  opacity: 1;\n  margin-top: 9px;\n  padding-left: 5px;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
